exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel .leftArrow{float:left}.carousel .rightArrow{float:right}.carousel .leftArrow,.carousel .rightArrow{margin-top:5rem;cursor:pointer}.carousel .displayContent{margin-left:6rem;margin-right:6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/carousel.scss
// module id = 1432
// module chunks = 0